import { render, staticRenderFns } from "./GroupAnalytics.vue?vue&type=template&id=37c5d512&scoped=true&"
import script from "./GroupAnalytics.vue?vue&type=script&lang=js&"
export * from "./GroupAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./GroupAnalytics.vue?vue&type=style&index=0&id=37c5d512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5d512",
  null
  
)

export default component.exports